/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".itemLocation[_ngcontent-%COMP%]{fill:var(--availability-fill);stroke:var(--availability-stroke)}div[_ngcontent-%COMP%]{position:absolute;--total-size:12px;width:var(--total-size);height:var(--total-size);margin-left:calc(var(--total-size)/ -2);margin-top:calc(var(--total-size)/ -2)}svg[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{cursor:pointer;stroke-width:1.5rem}svg[_ngcontent-%COMP%] > polygon[_ngcontent-%COMP%]{stroke-width:1rem}\n/*# sourceMappingURL=item-location.component.css.map*/"];
export { styles as styles };
